import { render, staticRenderFns } from "./coursewareEditor.vue?vue&type=template&id=1f53836c&"
import script from "./coursewareEditor.vue?vue&type=script&lang=js&"
export * from "./coursewareEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports